import { useQuery } from '@tanstack/react-query';
import { unwrap } from '../api/client.ts';
import { qk } from '../api/queryKeys.ts';
import { useTenant } from '../tenant/TenantProvider.tsx';
import { fetchAll } from './common.tsx';

/** Listes de référence de l'administration (toutes les pages), lues seulement si la permission est donnée. */
export function useEntities() {
  const { api, tenantId, can } = useTenant();
  return useQuery({
    queryKey: qk.entities(tenantId),
    enabled: can('entities.read'),
    queryFn: () =>
      fetchAll((cursor) => unwrap(api.GET('/entities', { params: { header: { 'X-Tenant-Id': tenantId }, query: { limit: 200, cursor } } }))),
  });
}

export function useSites() {
  const { api, tenantId, can } = useTenant();
  return useQuery({
    queryKey: qk.sites(tenantId),
    enabled: can('sites.read'),
    queryFn: () => fetchAll((cursor) => unwrap(api.GET('/sites', { params: { header: { 'X-Tenant-Id': tenantId }, query: { limit: 200, cursor } } }))),
  });
}

export function useRegions() {
  const { api, tenantId, can } = useTenant();
  return useQuery({
    queryKey: qk.regions(tenantId),
    enabled: can('territories.read'),
    queryFn: () => fetchAll((cursor) => unwrap(api.GET('/regions', { params: { header: { 'X-Tenant-Id': tenantId }, query: { limit: 200, cursor } } }))),
  });
}

export function useSectors() {
  const { api, tenantId, can } = useTenant();
  return useQuery({
    queryKey: qk.sectors(tenantId),
    enabled: can('territories.read'),
    queryFn: () => fetchAll((cursor) => unwrap(api.GET('/sectors', { params: { header: { 'X-Tenant-Id': tenantId }, query: { limit: 200, cursor } } }))),
  });
}

export function useRoles() {
  const { api, tenantId, can } = useTenant();
  return useQuery({
    queryKey: qk.roles(tenantId),
    enabled: can('roles.read'),
    queryFn: async () => (await unwrap(api.GET('/roles', { params: { header: { 'X-Tenant-Id': tenantId } } }))).items,
  });
}

export function useOrgUnits() {
  const { api, tenantId, can } = useTenant();
  return useQuery({
    queryKey: qk.orgUnits(tenantId),
    enabled: can('users.read'),
    queryFn: () => unwrap(api.GET('/org-units', { params: { header: { 'X-Tenant-Id': tenantId } } })),
  });
}

/** Tous les membres (pour les listes de choix : responsable d'un service, personne du journal). */
export function useAllMembers() {
  const { api, tenantId, can } = useTenant();
  return useQuery({
    queryKey: qk.allMembers(tenantId),
    enabled: can('users.read'),
    queryFn: () => fetchAll((cursor) => unwrap(api.GET('/users', { params: { header: { 'X-Tenant-Id': tenantId }, query: { limit: 200, cursor } } }))),
  });
}
